import { useQuery } from "@tanstack/react-query"
import { reactQueryKeys } from "reactQueryKeys/reactQueryKeys"
import { getPaymentMethods } from "services/PaymentMethodsService"

interface UseGetPaymentMethodsProps {
  enabled: boolean
}

export const useGetPaymentMethods = ({ enabled }: UseGetPaymentMethodsProps) => {
  return useQuery({
    queryKey: reactQueryKeys.getPaymentMethods(),
    queryFn: getPaymentMethods,
    enabled,
  })
}